import React from 'react';
import { LegalSection } from '../../constants/legalDocuments';

const LegalBlock: React.FC<{ section: LegalSection; headingLevel?: 'h2' | 'h3' }> = ({
  section,
  headingLevel = 'h2',
}) => {
  const HeadingTag = headingLevel;

  return (
    <div className={headingLevel === 'h2' ? 'mb-12' : 'mb-6'}>
      {section.title ? (
        <HeadingTag
          className={
            headingLevel === 'h2'
              ? 'text-2xl font-bold text-[#2B5A41] mb-6'
              : 'text-xl font-semibold text-[#2B5A41] mb-4'
          }
        >
          {section.title}
        </HeadingTag>
      ) : null}

      {section.paragraphs?.map((paragraph) => (
        <p key={paragraph} className="text-[#5F7167] mb-4 last:mb-0">
          {paragraph}
        </p>
      ))}

      {section.items && section.items.length > 0 && (
        <ul className="list-disc pl-6 text-[#5F7167] mb-4 space-y-1">
          {section.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}

      {section.subsections?.map((subsection) => (
        <LegalBlock key={`${section.title}-${subsection.title}-${subsection.paragraphs?.[0] ?? ''}`} section={subsection} headingLevel="h3" />
      ))}
    </div>
  );
};

export const LegalSectionContent: React.FC<{ sections: LegalSection[] }> = ({ sections }) => (
  <>
    {sections.map((section) => (
      <section key={section.title}>
        <LegalBlock section={section} />
      </section>
    ))}
  </>
);

export default LegalSectionContent;
